<template>
    <bottom-sheet v-model="shows" title="프로그램 미리보기" fullscreen persistent width="1210" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet class="scroll-primary pr-10" style="flex: 0 1 auto; overflow-y: auto; overflow-x: hidden">
                <expo-program-view v-bind="{ program }" isPreview />
            </v-sheet>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import { initExpoProgram } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import ExpoProgramView from "@/components/client/expo/programs/expo-program-view.vue";

export default {
    components: {
        BottomSheet,
        ExpoProgramView,
    },
    props: {
        program: { type: Object, default: initExpoProgram },
    },
    data: () => ({
        shows: false,
    }),
};
</script>
